/* eslint-disable eqeqeq */
import PersonalDefaultPage from "./PersonalDefaultPage";
import { color_grey_light, color_red_default, color_white, color_grey_dark, color_grey_ultra_light, color_green_dark, color_green_pastel_light } from "../../constants/colors";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import { OnestBoldBig, OnestBoldDefault, OnestBoldMed } from "../../components/styled/TextComponents";
import { BsDownload, BsEmojiFrown, BsPlusCircle } from "react-icons/bs";
import ZoomOutIcon from "../../components/icons/ZoomOutIcon";
import { useWindowDimensions } from "../../utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Config from "../../Config";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { setUser } from "../../store/UserSlice";
import { setLibraryFiles } from "../../store/LibraryFilesSlice"
import React from "react";

import AdminLibraryFileBlock from '../../components/blocks/Library/AdminLibraryFileBlock';
import ViewLibraryFileBlock from '../../components/blocks/Library/ViewLibraryFileBlock';
import NoFilesPlaceholder from '../../components/blocks/Library/NoFilesPlaceholder';
import ViewLibraryFolderBlock from "../../components/blocks/Library/ViewLibraryFolderBlock";
import ArrowIconLeft from "../../components/icons/ArrowIconLeft";
import { set } from "react-hook-form";
import { PageTitle } from "../../components/text/PageTitle";
import SearchBar from "../../components/inputs/FormTextInput/SearchBar";
import GoBackButton from "../../components/controls/Button/GoBackButton";
import { MIN_WIDTH_FOR_MENU } from "../../components/NavBar";
import { isDesktop } from "../../utilities/getDeviceType";
import { useI18n } from "../../i18n/I18nProvider";
import { libraryMatchesSearch } from "../../i18n/localizedContent";
import { isAdminUser } from "../../constants/adminAccess";

/* 
const GoBackButton = ({onClick, marginTop, position}) => {

    return (
        <div style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: color_white,
            color: color_red_default,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginTop: marginTop ? marginTop : 0,
            position: position ? position : "relative",
        }} 
        onClick={onClick}>
            <ArrowIconLeft
                style={{
                    marginRight: 5,
                }}

            />

        </div>
    )
}



 */
export const LibraryPage = () => {
    const { t } = useI18n();
    const libraryFiles = useSelector(state => state.libraryFiles);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState("")
    const [isAdminView, setIsAdminView] = useState(false);
    const [folders, setFolders] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState("");
    const { width: screenWidth } = useWindowDimensions();
    const user = useSelector(state => state.user);

    const isAdmin = isAdminUser(user.id);


    const fetchLibrary = useCallback(async () => {
        try {
            const response = await axios.get(`${Config.BACKEND_ADDR}/library/`);
            if (response.status === 200) {
                dispatch(setLibraryFiles(response.data));
                let sortedFiles = [...response.data]
                
                sortedFiles.sort((a, b) => a.index - b.index);
                const uniqueFolders = Array.isArray(sortedFiles)
                    ? Array.from(new Set(sortedFiles.map(file => file.folder).filter(folder => folder)))
                    : [];
                setFolders(uniqueFolders);
            }
        } catch (error) {
            console.error('Error fetching library files:', error);
        }
    }, [dispatch]);

    useEffect(() => {
        const filteredFiles = libraryFiles.filter(file =>
            libraryMatchesSearch(file, searchValue)
        );

        const uniqueFolders = Array.isArray(filteredFiles)
            ? Array.from(new Set(filteredFiles.map(file => file.folder).filter(folder => folder)))
            : [];
        setFolders(uniqueFolders);
    }, [libraryFiles, searchValue]);

    const handleNew = useCallback(async () => {
        // Логика для создания нового файла
        try {
            const response = await axios.post(`${Config.BACKEND_ADDR}/library/`, {
                folder: selectedFolder
            });
            if (response.status === 200) {
                await fetchLibrary();
            }
        } catch (error) {
            console.error('Error creating new file:', error);
        }
    }, [fetchLibrary, selectedFolder]);

    useEffect(() => {
        (async () => {
            console.log("navbaruser ", user)
            if (!user || Object.keys(user).length === 0) {
                try {
                    const data = await get_user();
                    dispatch(setUser(data));

                } catch (error) {
                    console.error('Error fetching user data:', error);
                    // Обработка ошибки, например, перенаправление на страницу входа
                    //navigate('/auth/login');
                }
            }
            fetchLibrary()
        })();
    }, [dispatch, fetchLibrary, user])

    useEffect(() => {
        let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod" // /api
        axios.get(backendAddr).then(response => {
            if (response.status === 200) {

                if (response.data.status === "not_paid") {
                    navigate("/billing/");
                }
            }
        }).catch(err => {
            console.warn("Ошибка проверки подписки в БД! ", err)
        })
    }, [navigate]);
    
    return (
        <PersonalDefaultPage>
            <div style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minWidth: 0,
                height: "auto",
                padding: 0,
                boxSizing: "border-box",
            }}>
                {screenWidth < 720 && selectedFolder
                    ? 
                    <GoBackButton 
                        onClick={() => setSelectedFolder("")} 
                        marginTop={-32}
                        position="absolute"
                        /> 
                    : null
                    }
                {screenWidth >= 720 ? 
                    <PageTitle title={t("Библиотека")} />
                    :
                    <PageTitle 
                    fontSize = {24} 
                    marginTop={selectedFolder ? 24 : 0}
                    marginBottom = {24}
                    title={selectedFolder ? selectedFolder : t("Библиотека")} />
                }
                {isAdmin && (
                    <button
                        style={{
                            alignSelf: "flex-start",
                            padding: "10px 20px",
                            backgroundColor: color_green_pastel_light,
                            border: `1px solid ${color_green_dark}`,
                            borderRadius: 8,
                            color: color_green_dark,
                            fontWeight: 600,
                            cursor: "pointer",
                            fontFamily: "Onest"
                        }}
                        onClick={() => setIsAdminView(prev => !prev)}
                    >
                        {isAdminView ? t("Выйти из режима админа") : t("Войти в режим админа")}
                    </button>
                )}
                {screenWidth >= 720 && selectedFolder ?
                    <div
                    style={{
                        marginTop: 6,
                        marginBottom: 20,
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: "100%",
                        gap: 20
                    }}
                    >
                        <GoBackButton onClick={() => setSelectedFolder("")} /> 
                        <OnestBoldMed style={{ color: color_grey_dark }} >{selectedFolder}</OnestBoldMed>
                    </div>
                    : null
                }
                <SearchBar setSearchValue={(value) => setSearchValue(value)} searchValue={searchValue} />
                
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: screenWidth >= MIN_WIDTH_FOR_MENU && isDesktop() && screenWidth < 1400 ? 8 : 16,
                    height: "100%",
                    width: "100%",
                    minWidth: 0,
                    boxSizing: "border-box",
                    alignItems: "center",
                    justifyContent: screenWidth < 1440 ? "center" : "flex-start",
                    }}>
                    {isAdminView &&
                        <div
                            onClick={handleNew}
                            style={{
                                width: screenWidth > 530 ? 190 : screenWidth - 80,
                                height: screenWidth > 530 ? 600 : "auto",
                                borderRadius: 20,
                                display: "flex",
                                flexDirection: "column",
                                padding: 15,
                                gap: 40,
                                backgroundColor: color_white,
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                border: `1px dashed ${color_grey_light}`,
                            }}
                        >
                            <BsPlusCircle
                                style={{
                                    fontSize: 60,
                                    color: color_grey_ultra_light
                                }}
                            />
                            <OnestBoldMed style={{ color: color_grey_dark }}>
                                {t("Добавить файл")}
                            </OnestBoldMed>
                        </div>
                    }
                    
                    {libraryFiles.filter(el => {
                        if (searchValue === "" || searchValue === null) return el.folder == selectedFolder
                        return libraryMatchesSearch(el, searchValue) && el.folder == selectedFolder
                    }).length === 0 && folders.length === 0 ? <NoFilesPlaceholder searchValue={searchValue} />
                        :
                        libraryFiles.filter(el => {
                            if (searchValue === "" || searchValue === null) return  el.folder == selectedFolder
                            return libraryMatchesSearch(el, searchValue) && el.folder == selectedFolder
                        }).map(el =>
                            isAdminView ? (
                                <AdminLibraryFileBlock
                                    key={el.id}
                                    libraryFileData={el}
                                    onFetchLibrary={fetchLibrary}
                                    folders={folders}
                                />
                            ) : (
                                el.index > 0 ?
                                    <ViewLibraryFileBlock
                                        key={el.id}
                                        libraryFileData={el}
                                    />
                                : null
                            )
                        )
                    }
                    {!selectedFolder && folders.map((folder, index) => (
                        <ViewLibraryFolderBlock
                            key={index}
                            name={folder}
                            libraryFilesData={libraryFiles.filter(el => el.folder === folder && el.index > 0)}
                            onClick={setSelectedFolder}
                        />
                    
                    ))}
                </div>
            </div>
        </PersonalDefaultPage>
    )
}